import * as Yup from 'yup'

export const schema = Yup.object().shape({
  name: Yup.string().required('team name is required'),
  leader_id: Yup.object().required('leader name is required').nullable(),
});